import type { RouteObject } from "react-router";
import { Sandbox } from "./Sandbox";
import { ReportAnalysis } from "./ReportAnalysis";
import { RulesTable } from "./RulesTable";
import { Analysis3 } from "./Analysis3";
import { ReportDebug } from "./ReportDebug";

export const sandboxRoute: RouteObject = {
  path: "sandbox",
  children: [
    { index: true, element: <Sandbox /> },
    { path: "report/analysis/rules", element: <RulesTable /> },
    { path: "report/analysis/:date", element: <ReportAnalysis /> },
    { path: "report/analysis3/:date", element: <Analysis3 /> },
    { path: "report/debug/:date", element: <ReportDebug /> },
  ],
};
